import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=35144293&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=35144293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35144293",
  null
  
)

export default component.exports